import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for L313 (正式發行文件列印)
// ============================================================

export interface ViewRequest {
  docNo: string;           // FL030_01 文件編號 (required)
  pageFrom?: number;       // FL130_02 頁次起始
  pageTo?: number;         // FL130_02 頁次結束
}

export interface DocumentHeader {
  fl030_01: string;        // 文件編號
  fl030_11: string;        // 文件名稱
  fl030_12: string | null; // 制訂日期
  fl030_13: string | null; // 修訂日期
  fl030_14: string;        // 代碼
  fl030_15: number;        // 版次
  fl030_16: number;        // 文件類型
  fl030_80: string;        // 狀態
}

export interface DocumentPage {
  fl130_01: string;        // 文件編號
  fl130_02: number;        // 頁次
  fl130_11: string;        // 頁面內容
}

export interface DocumentResponse {
  header: DocumentHeader | null;
  pages: DocumentPage[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const l313Api = {
  /** View a document with page range */
  async getDocument(params: ViewRequest): Promise<DocumentResponse> {
    const query: Record<string, string> = {};
    query['docNo'] = params.docNo.trim();
    if (params.pageFrom !== undefined && params.pageFrom > 0) query['pageFrom'] = String(params.pageFrom);
    if (params.pageTo !== undefined && params.pageTo > 0) query['pageTo'] = String(params.pageTo);
    const res = await apiClient.get('/api/l313/view', { params: query });
    return res.data;
  },
};
